import { Box, Flex, Text, Button, Card, Skeleton } from '@radix-ui/themes';

const GuardianStudentOverviewSkeleton = () => {
  return (
    <Flex direction="row" gap="4" align="start" width="100%" justify="between">
            <Skeleton width="100px" height="100px" />
            <Box style={{ flex: '1', padding: '0px' }}>
                <Skeleton width="100%" height="20px" mb="2"/>
                <Skeleton width="100%" height="20px" mb="2"/>
                <Skeleton width="100%" height="20px" mb="2"/>
            </Box>
            <Box>
                <Skeleton width="70px" height="70px" />
            </Box>
        </Flex>
  );
};

export default GuardianStudentOverviewSkeleton;
